import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { useImpressionCalculation } from './hooks/useImpressionCalculation';

export const ImpressionCalculation: React.FC = () => {
	const {
		data: { text, display },
	} = useImpressionCalculation();

	if (!display) return null;

	return (
		<Text variant="body" size="medium" className="text-typography-weak">
			{text}
		</Text>
	);
};
